<template>
  <div id="app" class="container">
    <FlashMessage position="right top"></FlashMessage>
    <MyTitleApp></MyTitleApp>
    <Message :msg="msg" v-show="msg" ></Message>
    <router-view />
  </div>
</template>

<script>
import "@fortawesome/fontawesome-free/css/all.css";
import Message from './components/Message.vue'
import MyTitleApp from "@/components/MyTitleApp.vue";

export default {
  data() {
    return {
      msg: ""
    };
  },
  components:{
    Message,
    MyTitleApp: MyTitleApp
  }
}
</script>

<style>

  ._vue-flash-msg-body {
    z-index: 99999 !important;
  }

.container {
  background-color: var(--primary-color);
  color: white !important;
}

input, textarea, select {
    background-color: #232627 !important;
    color: white !important;
}

.input-group-text {
  background-color: #282B2C !important;
  color: #D1CDC7 !important;
  border: 1px solid #564F46 !important;
}

table > thead > tr > th {
  color: #CECAC3 !important;
}

.table>tbody>tr>td, 
.table>tbody>tr>th {
  color: #CECAC3;
}

.table-striped>tbody>tr:nth-child(odd)>td, 
.table-striped>tbody>tr:nth-child(odd)>th {
  color: #CECAC3;
  background-color: var(--bs-table-striped-bg);
}

/*
.table-striped>tbody>tr:nth-child(even)>td, 
.table-striped>tbody>tr:nth-child(even)>th {
  background-color: yellow;
}
*/
</style>
